
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { SWR_useCommissionNumberSuggestions } from "../../Requests/Consumable.js";
import { AutoSuggestInput } from "../../Components/Input.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function CommissionNumberInput(props) {
    const patternInput = useTranslation();
    const suggestions = SWR_useCommissionNumberSuggestions();
    return createElement(AutoSuggestInput, {
        ComponentState: props.ComponentState,
        Label: patternInput[0]("general.commission"),
        OnChange: props.OnChange,
        Suggestions: defaultArg(suggestions.data, empty()),
        TestId: props.TestId,
        Value: props.Value,
    });
}

